import { action, autorun, makeObservable, observable } from 'mobx';

import type { CleanGeoData, RawGeoData } from '../../features/geography/types';
import { getRequest } from '../../services/api';
import { getErrorMessage } from '../../utils/errors';
import { singleFlight } from '../../utils/singleFlight';

export class LiveGeoStore {
  constructor() {
    autorun(() => this.getCurrentGeoData());

    makeObservable(this);
  }

  public fetchCurrentGeo = async () => {
    try {
      const res = await getRequest<{
        data: {
          clean: CleanGeoData | null;
          raw: RawGeoData | null;
        };
      }>('geography/current-geo');

      this.setCurrentGeo(res.data.clean, res.data.raw);

      return res.data.clean;
    } catch (geoError) {
      const errorMessage = getErrorMessage(geoError);
      console.error(`Error fetching current geo: ${errorMessage}`);
      return null;
    }
  };

  public getCurrentGeoData = singleFlight(this.fetchCurrentGeo);

  @observable
  public currentGeo: CleanGeoData | null = null;

  @observable
  public rawGeo: RawGeoData | null = null;

  @action
  private setCurrentGeo(geo: CleanGeoData | null, raw: RawGeoData | null) {
    this.currentGeo = geo;
    this.rawGeo = raw;
  }
}
export const liveGeoStore = new LiveGeoStore();
